import l from "./index47.mjs";
import F from "./index48.mjs";
import R from "./index49.mjs";
import { useDatePicker as w } from "./index39.mjs";
import { useLoadCarouselCalendar as U } from "./index50.mjs";
import e, { useState as v, useEffect as g } from "react";
import { useAtom as y } from "jotai";
import "@amenitiz/design-system";
import { arrivalDateAtom as j, departureDateAtom as q } from "./index26.mjs";
import { MonthTitle as z } from "./index42.mjs";
import { Days as G } from "./index43.mjs";
import { Week as H } from "./index41.mjs";
import { Loader as J } from "./index11.mjs";
import K from "classnames";
const f = ({
  children: t,
  onClick: a,
  isDisabled: o,
  customClassName: n,
  testId: i,
  ariaLabel: h
}) => /* @__PURE__ */ e.createElement(
  "button",
  {
    type: "button",
    className: K(l["carousel-scroller"], n),
    onClick: a,
    disabled: o,
    "data-testid": i,
    "aria-label": h
  },
  t
), O = ({
  onClick: t,
  isDisabled: a,
  ariaLabel: o
}) => /* @__PURE__ */ e.createElement(
  f,
  {
    onClick: t,
    isDisabled: a,
    customClassName: l["next-month-button"],
    testId: "next-month-button",
    ariaLabel: o
  },
  /* @__PURE__ */ e.createElement(R, null)
), Q = ({
  onClick: t,
  isDisabled: a,
  ariaLabel: o
}) => /* @__PURE__ */ e.createElement(
  f,
  {
    onClick: t,
    isDisabled: a,
    customClassName: l["previous-month-button"],
    testId: "previous-month-button",
    ariaLabel: o
  },
  /* @__PURE__ */ e.createElement(F, null)
), D = ({
  children: t
}) => /* @__PURE__ */ e.createElement(
  "nav",
  {
    className: l["month-title-with-navigation"],
    "aria-label": I18n.t("booking_engine.accessibility.carousel_navigation")
  },
  t
), M = ({ month: t, year: a }) => /* @__PURE__ */ e.createElement("div", { className: l["month-title-wrapper"] }, /* @__PURE__ */ e.createElement(z, { month: t, year: a })), V = ({ month: t, year: a, onClick: o, isDisabled: n, ariaLabel: i }) => /* @__PURE__ */ e.createElement(D, null, /* @__PURE__ */ e.createElement(
  Q,
  {
    onClick: o,
    isDisabled: n,
    ariaLabel: i
  }
), /* @__PURE__ */ e.createElement(M, { month: t, year: a })), X = ({ month: t, year: a, onClick: o, isDisabled: n, ariaLabel: i }) => /* @__PURE__ */ e.createElement(D, null, /* @__PURE__ */ e.createElement(M, { month: t, year: a }), /* @__PURE__ */ e.createElement(
  O,
  {
    onClick: o,
    isDisabled: n,
    ariaLabel: i
  }
)), Y = ({ month: t, daysProps: a, children: o, setWarning: n, timeLimitCustomMessage: i }) => /* @__PURE__ */ e.createElement("div", { "data-testid": "month" }, o, /* @__PURE__ */ e.createElement(H, null), /* @__PURE__ */ e.createElement(
  G,
  {
    ...a,
    year: t.year,
    month: t.month,
    days: t.days,
    availabilities: t.availabilities,
    previousDays: t.previousDays,
    setWarning: n,
    timeLimitCustomMessage: i
  }
)), Z = ({
  months: t,
  daysProps: a,
  onPreviousMonthClick: o,
  onNextMonthClick: n,
  isPreviousMonthDisabled: i,
  isNextMonthDisabled: h,
  setWarning: b,
  timeLimitCustomMessage: p
}) => /* @__PURE__ */ e.createElement(
  "section",
  {
    className: l["months-container"],
    "aria-label": "booking_engine.accessibility.carousel_calendar"
  },
  t.map((r, c) => /* @__PURE__ */ e.createElement(
    Y,
    {
      key: r.month + r.year,
      month: r,
      daysProps: a,
      setWarning: b,
      timeLimitCustomMessage: p
    },
    c === 0 ? /* @__PURE__ */ e.createElement(
      V,
      {
        month: r.month,
        year: r.year,
        onClick: o,
        isDisabled: i,
        ariaLabel: I18n.t("booking_engine.calendar.previous_month")
      }
    ) : /* @__PURE__ */ e.createElement(
      X,
      {
        month: r.month,
        year: r.year,
        onClick: n,
        isDisabled: h,
        ariaLabel: I18n.t("booking_engine.calendar.next_month")
      }
    )
  ))
), pe = ({
  setMaxDays: t,
  setMinDays: a,
  setWarning: o
}) => {
  const [n, i] = y(j), [h, b] = y(q), [p, r] = v([]), [c, d] = v(0), {
    months: m,
    isLoading: k,
    isReachLimit: N,
    isWithinLimit: C,
    checkIfAvailable: _,
    getAvailabilityForDate: E,
    getFirstUnavailableDate: I,
    fetchMoreAvailabilities: T,
    timeLimitCustomMessage: x
  } = U(), { scopedMap: L, setScopedMap: A } = w(
    { setMaxDays: t, setMinDays: a },
    E
  ), P = {
    dateFrom: n,
    dateTo: h,
    setDateFrom: i,
    setDateTo: b,
    isWithinLimit: C,
    checkIfAvailable: _,
    getAvailabilityForDate: E,
    getFirstUnavailableDate: I,
    scopedMap: L,
    setScopedMap: A,
    setWarning: o
  };
  g(() => {
    d(m.length - 2);
  }, [m]), g(() => {
    r(
      m.slice(c, c + 2)
    );
  }, [m, c]);
  const S = () => {
    const s = p[1], u = m[m.length - 1];
    (s == null ? void 0 : s.month) === (u == null ? void 0 : u.month) && (s == null ? void 0 : s.year) === (u == null ? void 0 : u.year) ? T() : d(
      (B) => B + 2
    );
  }, W = () => {
    d(
      (s) => s - 2
    );
  };
  return k ? /* @__PURE__ */ e.createElement("div", { className: l.loader }, /* @__PURE__ */ e.createElement(J, null)) : /* @__PURE__ */ e.createElement(
    "section",
    {
      "aria-label": I18n.t("booking_engine.accessibility.carousel_calendar")
    },
    /* @__PURE__ */ e.createElement(
      Z,
      {
        months: p,
        daysProps: P,
        onPreviousMonthClick: W,
        onNextMonthClick: S,
        isPreviousMonthDisabled: c === 0,
        isNextMonthDisabled: N,
        setWarning: o,
        timeLimitCustomMessage: x
      }
    )
  );
};
export {
  pe as CarouselCalendar
};
